import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { registerUser } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { ext } from "@/lib/ext";

const Register = () => {
  const { lang } = useLang();
  const { setSession } = useAuth();
  const e = ext[lang];
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (ev) => setForm((f) => ({ ...f, [k]: ev.target.value }));

  const submit = async (ev) => {
    ev.preventDefault();
    setErr(""); setLoading(true);
    try {
      const { token, user } = await registerUser(form.name, form.email, form.password);
      setSession(token, user);
      navigate("/account");
    } catch (e2) {
      const d = e2.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Eroare");
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-white px-4" data-testid="register-page">
      <form onSubmit={submit} className="w-full max-w-sm border border-border p-8">
        <Link to="/" className="mb-8 flex justify-center"><img src="/logo.png" alt="LAINER" className="h-6 w-auto" /></Link>
        <div className="mb-6 font-mono text-[11px] uppercase tracking-widest text-muted-foreground">{e.register}</div>
        {["name", "email", "password"].map((k) => (
          <div key={k} className="mb-4">
            <label className="mb-1 block font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{e[k]}</label>
            <input data-testid={`register-${k}`} type={k === "password" ? "password" : k === "email" ? "email" : "text"} value={form[k]} onChange={set(k)} required
              className="w-full border border-border px-3 py-3 font-mono text-sm focus:outline-none focus:ring-1 focus:ring-foreground" />
          </div>
        ))}
        {err && <div data-testid="register-error" className="mb-4 font-mono text-[11px] uppercase tracking-widest text-destructive">{err}</div>}
        <button data-testid="register-submit" disabled={loading} type="submit" className="w-full bg-foreground py-4 text-sm uc font-medium text-white transition-opacity hover:opacity-85 disabled:opacity-50">
          {loading ? "..." : e.register}
        </button>
        <div className="mt-4 text-center font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
          {e.haveAccount} <Link to="/login" className="underline underline-offset-4 hover:text-foreground">{e.login}</Link>
        </div>
      </form>
    </main>
  );
};

export default Register;
